const SET_USER_INFO = 'SET_USER_INFO';
const SET_MODELS = 'SET_MODELS';
const SET_DEFECTS = 'SET_DEFECTS';
const SET_MODELS_LOADING = 'SET_MODELS_LOADING';
const SET_DEFECTS_LOADING = 'SET_DEFECTS_LOADING';
const SET_USER_INFO_LOADING = 'SET_USER_INFO_LOADING';
const SET_USE_CASE = 'SET_USE_CASE';
const SET_USE_CASE_LOADING = 'SET_USE_CASE_LOADING';
const SET_FEATURE_FLAGS = 'SET_FEATURE_FLAGS';
const SET_FEATURE_FLAGS_LOADING = 'SET_FEATURE_FLAGS_LOADING';
const SET_IS_UR_OR_ENABLED = 'SET_IS_UR_OR_ENABLED';

export {
  SET_DEFECTS,
  SET_DEFECTS_LOADING,
  SET_FEATURE_FLAGS,
  SET_FEATURE_FLAGS_LOADING,
  SET_IS_UR_OR_ENABLED,
  SET_MODELS,
  SET_MODELS_LOADING,
  SET_USE_CASE,
  SET_USE_CASE_LOADING,
  SET_USER_INFO,
  SET_USER_INFO_LOADING,
};
